import { Injectable } from "@angular/core";
import { ComponentStore } from "@ngrx/component-store";
import {
    endOfDay,
    endOfMonth,
    endOfWeek,
    endOfYear, isSameDay, isSameMonth, isSameWeek, isSameYear,
    startOfDay,
    startOfMonth,
    startOfWeek,
    startOfYear
} from "date-fns";

export enum RangePickerPeriod {
    daily = 1,
    weekly = 2,
    monthly = 3,
    yearly = 4,
    custom = 5,
}

export const availablePeriods = [
    RangePickerPeriod.daily,
    RangePickerPeriod.weekly,
    RangePickerPeriod.monthly,
    RangePickerPeriod.yearly,
];

export class RangePickerState {
    period: RangePickerPeriod;
    periodStart: Date;
    periodEnd: Date;
}

@Injectable()
export class RangePickerComponentStore extends ComponentStore<RangePickerState> {
    constructor() {
        super({
            period: RangePickerPeriod.daily,
            periodStart: new Date(),
            periodEnd: new Date(),
        });
    }

    readonly datasource$ = this.select((state) => state);

    readonly period$ = this.select((state) => state.period);

    init(rangeState: RangePickerState) {
        this.setState((state) => {
            return {
                ...state,
                period: rangeState.period,
                periodStart: rangeState.periodStart,
                periodEnd: rangeState.periodEnd,
            };
        });
    }

    selectPeriod(period: number) {
        let periodStart = new Date();
        let periodEnd = new Date();
        switch (period) {
            case RangePickerPeriod.daily:
                periodStart = startOfDay(periodStart);
                periodEnd = endOfDay(periodStart);
                break;
            case RangePickerPeriod.weekly:
                periodStart = startOfWeek(periodStart);
                periodEnd = endOfWeek(periodStart);
                break;
            case RangePickerPeriod.monthly:
                periodStart = startOfMonth(periodStart);
                periodEnd = endOfMonth(periodStart);
                break;
            case RangePickerPeriod.yearly:
                periodStart = startOfYear(periodStart);
                periodEnd = endOfYear(periodStart);
                break;
        }
        this.setState((state) => {
            return {
                ...state,
                period: period,
                periodStart: periodStart,
                periodEnd: periodEnd,
            };
        });
    }

    changeDate(start: Date, end: Date) {
        let period = RangePickerPeriod.custom;
        if (isSameDay(start, end)) {
            period = RangePickerPeriod.daily;
        } else if (isSameWeek(start, end) && isSameDay(startOfWeek(end), start) && isSameDay(endOfWeek(start), end)) {
            period = RangePickerPeriod.weekly;
        } else if (isSameMonth(start, end) && isSameDay(startOfMonth(end), start) && isSameDay(endOfMonth(start), end)) {
            period = RangePickerPeriod.monthly;
        } else if (isSameYear(start, end) && isSameDay(startOfYear(end), start) && isSameDay(endOfYear(start), end)) {
            period = RangePickerPeriod.yearly;
        }
        
        this.setState((state) => {
            return {
                ...state,
                period: period,
                periodStart: startOfDay(start),
                periodEnd: endOfDay(end),
            };
        });
    }
}
